import { useEffect, useRef, useState } from 'react';
import { createPortal } from 'react-dom';
import css from './index.module.scss';
import IoMdCloseCircle from '@/components/UI/svg/Icons/IoMdCloseCircle';
import Aliplayer from '@/components/UI/Aliplayer';

export enum PlayerType {
    YouTube = 'YouTube',
    Alibaba = 'Alibaba',
    Bilibili = 'Bilibili',
    // Facebook = 'Facebook',
}

type params = {
    visible: boolean;
    source: string;
    playerType?: PlayerType | string;
    onClose: () => void;
};

export default function EFVideoModal({ visible, source, playerType = PlayerType.YouTube, onClose }: params) {
    const videoRef = useRef(null);
    const bRef = useRef(null);
    const [isClient, setIsClient] = useState(false);

    // 隐藏滚动条
    useEffect(() => {
        document.documentElement.style.overflow = visible ? 'hidden' : '';
        return () => {
            document.documentElement.style.overflow = '';
        };
    }, [visible]);

    useEffect(() => {
        if (typeof window !== 'undefined') {
            setIsClient(true);
        }
    }, []);

    const renderPlayer = (type: PlayerType | string) => {
        switch (type) {
            case PlayerType.YouTube:
                return (
                    <iframe
                        ref={videoRef}
                        className="player-frame player-youtube"
                        onLoad={() => {
                            if (videoRef.current) {
                                videoRef.current.style.display = 'block';
                            }
                        }}
                        src={source}
                        frameBorder="0"
                        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture; autoplay"
                    />
                );
            case PlayerType.Alibaba:
                return (
                    /**
                     * 多清晰度播放，source传入一个JSON
                     *
                     * "OD": "<原画URL>"
                     * "FD": "<流畅URL>"
                     * "LD"："<标清URL>"
                     * "SD": "<高清URL>" 480P
                     * "HD": "<超清URL>" 720P
                     * "2K": "<2K URL>" 1080P
                     * "4K": "<4K URL>" UHD
                     *
                     * 默认播放率按 source 排序
                     */
                    //  source: {
                    //     "HD":"http://xxxxx/player/hdexample.mp4",
                    //     "SD":"http://xxxxx/player/sdexample.mp4"
                    // }
                    <Aliplayer className="player-frame player-alibaba" source={source} autoplay={true} />
                );
            case PlayerType.Bilibili:
                return (
                    <iframe
                        ref={bRef}
                        className="player-frame player-bilibili"
                        onLoad={() => {
                            if (bRef.current) {
                                (bRef.current as HTMLDivElement).style.display = 'block';
                            }
                        }}
                        src={source}
                        scrolling="no"
                        // border={0}
                        frameBorder="no"
                        // framespacing="0"
                        allowFullScreen={true}
                    ></iframe>
                );
            default:
                return <></>;
        }
    };

    return (
        <>
            {isClient &&
                createPortal(
                    <div className={css.EFVideoModal}>
                        {visible && (
                            <div className="ef-video-modal">
                                {renderPlayer(playerType)}
                                <IoMdCloseCircle className="close-btn" onClick={onClose} />
                            </div>
                        )}
                    </div>,
                    document.body,
                )}
        </>
    );
}
